// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Thorchain Unchained API
 * Provides access to thorchain chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AffiliateFee
 */
export interface AffiliateFee {
    /**
     * 
     * @type {string}
     * @memberof AffiliateFee
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateFee
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateFee
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateFee
     */
    blockHash?: string;
    /**
     * 
     * @type {number}
     * @memberof AffiliateFee
     */
    blockHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof AffiliateFee
     */
    timestamp?: number;
    /**
     * 
     * @type {string}
     * @memberof AffiliateFee
     */
    txId?: string;
}

/**
 * Check if a given object implements the AffiliateFee interface.
 */
export function instanceOfAffiliateFee(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AffiliateFeeFromJSON(json: any): AffiliateFee {
    return AffiliateFeeFromJSONTyped(json, false);
}

export function AffiliateFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateFee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'blockHash': !exists(json, 'blockHash') ? undefined : json['blockHash'],
        'blockHeight': !exists(json, 'blockHeight') ? undefined : json['blockHeight'],
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
        'txId': !exists(json, 'txId') ? undefined : json['txId'],
    };
}

export function AffiliateFeeToJSON(value?: AffiliateFee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'amount': value.amount,
        'asset': value.asset,
        'blockHash': value.blockHash,
        'blockHeight': value.blockHeight,
        'timestamp': value.timestamp,
        'txId': value.txId,
    };
}

